import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getFileUrl } from '../config/api';
import NotificationBell from './NotificationBell';

const CaregiverNavbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-primary-600 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-6 sm:py-6">
        <div className="flex justify-between items-center relative">
          {/* Centered logo on mobile, left-aligned on desktop */}
          <h1 className="text-2xl sm:text-3xl font-bold font-proyas tracking-wider text-white sm:block absolute left-1/2 transform -translate-x-1/2 sm:relative sm:left-0 sm:transform-none">PROYAS</h1>

          {/* Mobile Notification Bell */}
          <div className="sm:hidden absolute right-0 top-1/2 transform -translate-y-1/2">
            <NotificationBell />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden sm:flex items-center space-x-4 lg:space-x-8">
            <button
              onClick={() => navigate('/caregiver/dashboard')}
              className={`text-white font-semibold transition-colors text-base lg:text-lg active:scale-95 ${
                isActive('/caregiver/dashboard') ? 'border-b-2 border-white pb-1' : 'hover:text-white/80'
              }`}
            >
              Home
            </button>
            
            <button
              onClick={() => navigate('/caregiver/jobs')}
              className={`text-white font-semibold transition-colors text-base lg:text-lg active:scale-95 ${
                isActive('/caregiver/jobs') ? 'border-b-2 border-white pb-1' : 'hover:text-white/80'
              }`}
            >
              Jobs
            </button>

            <button
              onClick={() => navigate('/wallet')}
              className={`text-white font-semibold transition-colors text-base lg:text-lg active:scale-95 ${
                isActive('/wallet') ? 'border-b-2 border-white pb-1' : 'hover:text-white/80'
              }`}
            >
              Wallet
            </button>
            
            <div className="flex items-center space-x-3 lg:space-x-4 ml-4">
              <NotificationBell />
              
              <button
                onClick={() => navigate('/profile')}
                className="flex items-center gap-2 hover:opacity-80 transition-opacity"
                title="Go to Profile"
              >
                {user?.profilePhoto ? (
                  <img
                    src={getFileUrl(user.profilePhoto)}
                    alt={user.firstName || 'User'}
                    className="w-8 h-8 rounded-full object-cover border-2 border-white/30 cursor-pointer"
                  />
                ) : (
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center cursor-pointer">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
                <span className="text-white text-sm lg:text-base font-medium hidden lg:block">
                  {user?.firstName || 'Guest'}
                </span>
              </button>
              
              <button
                onClick={logout}
                className="text-white/70 hover:text-white text-sm transition-colors"
                title="Logout"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CaregiverNavbar;
